module.exports = __webpack_public_path__ + "static/media/ajuda.2c220775.svg";